import { formatPrice } from "../../helpers";

const LineItem = (item) => {
  const {
    title,
    product_title,
    variant_title,
    variant_id,
    variant_inventory,
    featured_image,
    final_line_price,
    original_line_price,
    quantity,
    key,
    handle,
  } = item;

  const isCart = window.location.pathname === "/cart";
  return `
  <div
    class="line-item ${isCart ? "line-item--large" : ""}"
    data-controller="line-item"
    data-handle="${handle}"
    data-line-item-variant-value="${variant_id}"
    data-line-item-sample-value="${variant_title?.includes("Sample") || false}"
    data-product="${item.product_id}"
  >
    <img
      class="line-item__image"
      src="${featured_image.url}"
      alt="${title}"
      height="${isCart ? 150 : 110}"
      width="${isCart ? 150 : 110}"
      loading="lazy"
    />
    <div class="line-item__content">
      <h3 class="line-item__title">${product_title}</h3>
      ${
        variant_title
          ? `<p class="line-item__variant">${variant_title}</p>`
          : ""
      }
      <div class="line-item__price-group">
        ${
          original_line_price > final_line_price
            ? `<del class="line-item__price-compare">${formatPrice(
                original_line_price,
                true,
                false,
                false
              )}</del>`
            : ""
        }
        <p class="line-item__price">${formatPrice(
          final_line_price,
          true,
          false,
          false
        )}</p>
      </div>
      <small>Quantity</small>
      <div class="line-item__quantity">
        <button type="button" data-action="line-item#handleUpdateQuantity" data-line-item-direction-param="decrease">-</button>
          <input
            data-line-item-target="quantity"
            type="number"
            disabled
            value="${quantity}"
            min="1"
            ${variant_inventory > 0 ? `max="${variant_inventory}"` : ""}
          />
        <button type="button" data-action="line-item#handleUpdateQuantity" data-line-item-direction-param="increase">+</button>
      </div>
      <a href="#" class="line-item__remove" data-action="line-item#handleRemoveItem">Remove</a>
    </div>
  </div>
  `;
};

export default LineItem;
